import React from 'react'

function TenderTextParapet() {
    return (
        <embed src="\pdfs\EAT1.2.7_BL-V_Parapet_outlet_kr.pdf" width="100%" height="2100px" />
    )
}

export default TenderTextParapet